import { getBase64 } from '@/utils/base64';

const MAX_FILE_SIZE = 25000000;

export default class SignatureFile {
  constructor(file) {
    this.is = file;
    this.base64 = null;
    this.base64Content = null;
    this.arrayBuffer = null;

    this.getBase64 = () => this.setBase64();
    this.getArrayBuffer = () => this.setArrayBuffer();
  }

  setBase64() {
    const base64Data = (base64) => ({
      base64,
      base64Content: base64.split(',').at(-1),
    });
    if (this.base64) return new Promise((resolve) => { resolve(base64Data(this.base64)); });
    return new Promise((resolve) => {
      getBase64(this.is)
        .then((res) => {
          const data = base64Data(res);
          this.base64 = data.base64;
          this.base64Content = data.base64Content;
          resolve(data);
        });
    });
  }

  setArrayBuffer() {
    if (this.arrayBuffer) return new Promise((resolve) => { resolve(this.arrayBuffer); });
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        this.arrayBuffer = reader.result;
        resolve(reader.result);
      };
      if (this.is.size > MAX_FILE_SIZE) {
        reject(new Error(`Файл для подписи не должен превышать ${MAX_FILE_SIZE / 1000000}МБ`));
        return;
      }
      reader.readAsArrayBuffer(this.is);
    });
  }
}
